import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingBag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0.375 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 8.33331C13 9.21737 12.6839 10.0652 12.1213 10.6903C11.5587 11.3155 10.7956 11.6666 10 11.6666C9.20435 11.6666 8.44129 11.3155 7.87868 10.6903C7.31607 10.0652 7 9.21737 7 8.33331",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.32727 5.02832H16.6728",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.55 4.55585C3.35527 4.84435 3.25 5.19524 3.25 5.55585V16.6667C3.25 17.1087 3.40804 17.5326 3.68934 17.8452C3.97064 18.1578 4.35218 18.3334 4.75 18.3334H15.25C15.6478 18.3334 16.0294 18.1578 16.3107 17.8452C16.592 17.5326 16.75 17.1087 16.75 16.6667V5.55585C16.75 5.19524 16.6447 4.84435 16.45 4.55585L14.95 2.33335C14.8103 2.12636 14.6291 1.95835 14.4208 1.84264C14.2125 1.72693 13.9829 1.66669 13.75 1.66669H6.25C6.01713 1.66669 5.78746 1.72693 5.57918 1.84264C5.3709 1.95835 5.18972 2.12636 5.05 2.33335L3.55 4.55585Z",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgShoppingBag;
